import Api from 'api'

const config = {
  baseURL: '/api/app/v1',
}
const api = new Api(config)

api.getNetworks = ({ ...rest }) => api.get('/networks', { ...rest })

api.generateLogin = ({ ...rest }) =>
  api.get('/network-accounts/generate-login', { ...rest })

api.generateLoginBulk = ({ ...rest }) =>
  api.get('/network-accounts/generate-login/bulk', { ...rest })

api.getNetworkData = ({ networkId, ...rest }) =>
  api.get(`/networks/${networkId}`, { ...rest })

api.getNetworkSettings = ({ networkId, ...rest }) =>
  api.get(`/networks/${networkId}/settings`, { ...rest })

api.getNetworkPaymentAccounts = ({ networkId, ...rest }) =>
  api.get(`/networks/${networkId}/payment-profiles`, { ...rest })

api.getNetworkNotifications = ({ networkId, ...rest }) =>
  api.get(`/networks/${networkId}/notifications`, { ...rest })

api.getNetworkText = ({ networkId, textKey, ...rest }) =>
  api.get(`/networks/${networkId}/text/${textKey}`, { ...rest })

api.getAccountTransfers = ({ networkId, accountId, ...rest }) =>
  api.get(`/networks/${networkId}/account/${accountId}/transfers`, { ...rest })

api.getAccessSettings = ({ networkType, accountId }) =>
  api.get(`/networks/${networkType}/accounts/${accountId}/access-settings`)

api.getNetworkCompany = ({ networkId, ...rest }) =>
  api.get(`/networks/${networkId}/company`, { ...rest })

/**
 * @deprecated
 */
// api.addNetworkAccount = ({ ...rest }) =>
//   api.post('/network-accounts', { ...rest })

/**
 * @deprecated
 */
// api.getNetworkAccountById = ({ accountId, ...rest }) =>
//   api.get(`/network-accounts/${accountId}`, { ...rest })

api.archiveNetworkAccountById = ({ accountId }) =>
  api.post(`/network-accounts/${accountId}/archive`)

api.getTaxInfo = ({ accountId, ...rest }) =>
  api.get(`/network-accounts/${accountId}/advertiser-info`, { ...rest })

api.patchTaxInfo = ({ accountId, ...rest }) =>
  api.patch(`/network-accounts/${accountId}/advertiser-info`, { ...rest })

api.createYandexSubscriptionCampaign = ({ networkType, accountId, ...rest }) =>
  api.post(`/networks/${networkType}/${accountId}/campaigns`, { ...rest })

api.loadYandexSubscriptionCampaigns = ({ networkType, accountId, ...rest }) =>
  api.get(`/networks/${networkType}/${accountId}/campaigns`, { ...rest })

api.loadYandexSubscriptionCampaign = ({
  networkType,
  accountId,
  campaignId,
  ...rest
}) =>
  api.get(`/networks/${networkType}/${accountId}/campaigns/${campaignId}`, {
    ...rest,
  })

api.deleteYandexSubscriptionCampaigns = ({
  networkType,
  accountId,
  campaignId,
  ...rest
}) =>
  api.delete(`/networks/${networkType}/${accountId}/campaigns/${campaignId}`, {
    ...rest,
  })

api.getPrice = ({ networkType, accountId, campaignId }) =>
  api.get(`/networks/${networkType}/${accountId}/campaign/${campaignId}/price`)

api.applyPromoCode = ({ networkType, accountId, campaignId, ...rest }) =>
  api.post(
    `/networks/${networkType}/${accountId}/campaign/${campaignId}/promocode/apply`,
    { ...rest },
  )

api.discardPromoCode = ({ networkType, accountId, campaignId }) =>
  api.post(
    `/networks/${networkType}/${accountId}/campaign/${campaignId}/promocode/discard`,
  )

api.startYandexSubscriptionCampaign = ({
  networkType,
  accountId,
  campaignId,
  ...rest
}) =>
  api.post(
    `/networks/${networkType}/${accountId}/campaigns/${campaignId}/start`,
    { ...rest },
  )

api.getNetworkAuthUrl = ({ networkType }) =>
  api.get(`/networks/${networkType}/oauth/auth-url`)

api.getNetworkExtraData = ({ networkType, accountId }) =>
  api.get(`/networks/${networkType}/${accountId}/extra-data`)

export default api
